export enum RelativeDateFilter {
  today = 'today',
  todayAndPast = 'todayAndPast',
  currentWeek = 'currentWeek',
  currentMonth = 'currentMonth',
  currentYear = 'currentYear',
}
